import { Injectable } from '@angular/core';
import {
	CachePolicy,
	CachePolicyEntity,
	DcBaseInitializationService,
	UrlService,
} from '@datachain/ui-sdk/common';
import { Observable } from 'rxjs';

import { IInstanceModel } from './instance.model';
import { DcBaseRequester } from '../../core/dc-base.requester';
import { IOrganizationModel } from '../common/models/organization.model';

@Injectable({
	providedIn: 'root',
})
export class ProfileRequester extends DcBaseRequester<unknown> {
	protected resource;
	protected elementsListUrl;
	protected singleElementUrl;

	public constructor(private readonly urlService: UrlService) {
		super();
		this.resource = '';
		this.elementsListUrl = this.resource;
		this.singleElementUrl = this.resource;
	}

	public getOrganizationById(
		organizationId: number,
	): Observable<IOrganizationModel> {
		const endpoint = DcBaseInitializationService.getResource(
			'ORGANIZATION_BY_ID_PRIVATE_API',
		);
		const url = this.urlService.generateUrl(
			endpoint,
			{
				organizationId,
			},
			{},
		);

		const cachePolicy = CachePolicyEntity.build({
			evictTimeoutInSeconds: 60,
			isCacheable: false,
			policy: CachePolicy.NetworkOnly,
		});

		return this.get<IOrganizationModel>(url, cachePolicy);
	}

	public getAvailableInstanceModules(): Observable<
		ReadonlyArray<IInstanceModel>
	> {
		const endpoint = '/private-dmp-api/myself/instances'; // to modify
		return this.get<ReadonlyArray<IInstanceModel>>(
			endpoint,
			CachePolicyEntity.build({
				policy: CachePolicy.CacheOnly,
				evictTimeoutInSeconds: 3600,
				isCacheable: true,
			}),
		);
	}
}
